import { useCallback } from 'react';

import {
  ChangeMaterialsFiltersFunc,
  FetchMaterialsFilterFields
} from '../../../../../materials/materialsTypes';

import { useCurrentUser } from '../../../../../../auth/hooks/useAuth';

import { MaterialsPermissions } from '../../../../../materials/materialsConstants';

interface ThreeDStockMaterialsSearchOptions {
  changeMaterialsFilters?: ChangeMaterialsFiltersFunc;
}

function useThreeDStockMaterialsSearch({
  changeMaterialsFilters
}: ThreeDStockMaterialsSearchOptions) {
  const currentUser = useCurrentUser();

  const handleSearch = useCallback<(value: string) => void>(
    (value) => {
      const searchWithSku = currentUser.hasPermissions(
        MaterialsPermissions.READ_MATERIALS_NAME_SKU_TAGS_FILTER
      );

      const field = searchWithSku
        ? FetchMaterialsFilterFields.NAME_SKU_TAGS
        : FetchMaterialsFilterFields.NAME;

      const removeFilters = value ? [] : [field];

      changeMaterialsFilters(
        { [field]: searchWithSku ? value : { ilike: value } },
        removeFilters
      );
    },
    [changeMaterialsFilters, currentUser]
  );

  return {
    handleSearch
  };
}

export default useThreeDStockMaterialsSearch;
